exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.setting_heading[data-v-249e86ef] {\n  height: 29px;\n}\n", ""]);

// exports
